import { Box, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Ellipsis from '@material-ui/icons/MoreVert';
import { FC, MouseEvent, useState } from 'react';

interface MenuItem {
  label: string;
  link?: string;
  onClick?: () => void;
  disabled?: boolean;
  dataTestId?: string;
}

interface EllipsisMenuProps {
  menuItems?: MenuItem[];
  buttonDataTestId?: string;
  menuDataTestId?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItemBtn: {
      padding: theme.spacing(0),
    },
  }),
);

const EllipsisMenuIcon: FC<EllipsisMenuProps> = ({ menuItems = [], buttonDataTestId, menuDataTestId }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box display="flex">
      {menuItems.length > 0 && (
        <>
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={handleClick}
            className={classes.menuItemBtn}
            disableFocusRipple
            disableRipple
            disableTouchRipple
            color="secondary"
            data-testid={buttonDataTestId}
          >
            <Ellipsis />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            getContentAnchorEl={null}
            data-testid={menuDataTestId}
          >
            {menuItems.map((item, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  handleClose();
                  item.onClick ? item.onClick() : item.link && window.open(item.link, '_blank');
                }}
                disabled={item.disabled}
                data-testid={item.dataTestId}
              >
                <Typography variant="body1">{item.label}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
};

export default EllipsisMenuIcon;
